module.exports = __webpack_public_path__ + "assets/749542588fff8b145e4b007e1741b143.png";